import ChartAPI from "../../apps/common/chart-api";
import "slugify";


// Yandex.Metrika counter
(function (m, e, t, r, i, k, a) {
    m[i] =
        m[i] ||
        function () {
            (m[i].a = m[i].a || []).push(arguments);
        };
    m[i].l = 1 * new Date();
    for (var j = 0; j < document.scripts.length; j++) {
        if (document.scripts[j].src === r) {
            return;
        }
    }
    (k = e.createElement(t)),
        (a = e.getElementsByTagName(t)[0]),
        (k.async = 1),
        (k.src = r),
        a.parentNode.insertBefore(k, a);
})(window, document, "script", "https://mc.yandex.ru/metrika/tag.js", "ym");
ym(91126829, "init", {
    clickmap: true,
    trackLinks: true,
    accurateTrackBounce: true,
    webvisor: true,
});

function setWithExpiry(key, value, ttl) {
    const now = new Date();
    const item = {
        value,
        expiry: now.getTime() + ttl,
    };
    localStorage.setItem(key, JSON.stringify(item));
}

function getWithExpiry(key) {
    const itemStr = localStorage.getItem(key);
    if (!itemStr) return null;

    const item = JSON.parse(itemStr);
    const now = new Date();

    if (now.getTime() > item.expiry) {
        localStorage.removeItem(key);
        return null;
    }

    return item.value;
}

const now = new Date();
const fourteenDaysAgo = new Date(Date.now() - 14 * 24 * 60 * 60 * 1000);

const dateRangeFallback = {
    startDate: fourteenDaysAgo,
    endDate: now,
};

const savedDateRange = getWithExpiry("dateRange");
const savedDateRangeComparing = getWithExpiry("dateRangeComparing");

const parsedDateRange = savedDateRange
    ? {
        startDate: new Date(savedDateRange.startDate),
        endDate: new Date(savedDateRange.endDate),
    }
    : null;

const parsedDateRangeComparing = savedDateRangeComparing
    ? {
        startDate: new Date(savedDateRangeComparing.startDate),
        endDate: new Date(savedDateRangeComparing.endDate),
    }
    : null;

export default {
    namespaced: true,
    state: {
        searchEngines: JSON.parse(localStorage.getItem("searchEngines")) || ["yandex", "google"],
        deviceTypes: JSON.parse(localStorage.getItem("deviceTypes")) || ["desktop", "mobile"],
        geoLocations: (() => {
            try {
                const saved = localStorage.getItem("geolocation");
                return saved ? JSON.parse(saved) : [];
            } catch (e) {
                return [];
            }
        })(),
        keywordsTypes: (() => {
            try {
                const saved = localStorage.getItem("keywordsTypes");
                return saved ? JSON.parse(saved) : [];
            } catch (e) {
                return [];
            }
        })(),
        optionsSearchEngines: ["yandex", "google"],
        optionsDeviceTypes: ["desktop", "mobile"],
        optionsKeywordsTypes: [],
        keywords: (() => {
            try {
                const saved = localStorage.getItem("keywords");
                return saved ? JSON.parse(saved) : [];
            } catch (e) {
                return [];
            }
        })(),
        optionsKeywords: [],
        competitorsFilter: null,
        advertisersFilter: null,
        slice: null,
        dateRange: parsedDateRange || dateRangeFallback,
        dateRangeComparing: parsedDateRangeComparing || dateRangeFallback,
        dateRangeComparingString: `${now.toISOString().substring(0, 10).split("-").reverse().join(".")} - ${now.toISOString().substring(0, 10).split("-").reverse().join(".")}`,
        comparing: localStorage.getItem("comparing")
            ? JSON.parse(localStorage.getItem("comparing"))
            : true,
        optionsGeoLocation: [],
        resultsPeriod: "",
    },
    actions: {
        initSettings({commit}) {
            let minutesToSubstract = 1440; // oneDay Minutes

            let startDate = new Date();
            let endDate = new Date();

            let startDateComparing = new Date();
            let endDateComparing = new Date();

            const item = getWithExpiry("dateRange");
            const itemComparing = getWithExpiry("dateRangeComparing");

            if (item === null) {
                let currentDate = new Date();

                startDate = new Date(currentDate.getTime() - 14 * minutesToSubstract * 60000);
                startDate.setHours(10);
                endDate = new Date(currentDate.getTime() - minutesToSubstract * 60000);
                endDate.setHours(10);
            } else {
                startDate = new Date(item.startDate);
                endDate = new Date(item.endDate);
            }

            if (itemComparing === null) {
                startDateComparing = new Date(startDate.getTime() - 14 * minutesToSubstract * 60000);
                startDateComparing.setHours(10);
                endDateComparing = new Date(startDate.getTime() - minutesToSubstract * 60000);
                endDateComparing.setHours(10);
            } else {
                startDateComparing = new Date(itemComparing.startDate);
                endDateComparing = new Date(itemComparing.endDate);
            }


            commit("updateDateRange", {
                startDate: startDate,
                endDate: endDate,
            });
            commit("updateDateRangeComparing", {
                startDate: startDateComparing,
                endDate: endDateComparing,
            });
        },

        async fetchOptionsKeywordsTypes(
            {commit, rootGetters},
            {
                currentProjectID = null,
                startDate,
                endDate,
                startDateComparing,
                endDateComparing
            } = {}
        ) {
            let studObj = new ChartAPI();

            if (!currentProjectID) {
                currentProjectID = rootGetters["currentProjectId"];
            }

            if (!startDate || !endDate) {
                startDate = rootGetters["filters/dateRange"].startDate.toISOString().split("T")[0];
                endDate = rootGetters["filters/dateRange"].endDate.toISOString().split("T")[0];
            }
            if (!startDateComparing || !endDateComparing) {
                startDateComparing = rootGetters["filters/dateRangeComparing"].startDate.toISOString().split("T")[0];
                endDateComparing = rootGetters["filters/dateRangeComparing"].endDate.toISOString().split("T")[0];
            }
            
            let jsonOurResponse = await studObj.sendRequest(
                "getKeywordsTypes",
                currentProjectID,
                null,
                {
                    start_date: startDate,
                    end_date: endDate,
                    start_date_comparing: startDateComparing,
                    end_date_comparing: endDateComparing
                }
            );

            if (jsonOurResponse && jsonOurResponse.length) {
                commit("updateOptionsKeywordsTypes", jsonOurResponse);
            }
        },


        async fetchOptionsKeywords({commit, rootGetters}) {
            let studObj = new ChartAPI();
            let jsonOurResponse = await studObj.sendRequest(
                "getKeywords",
                rootGetters["currentProjectId"]
            );
            if (jsonOurResponse.length) {
                commit("updateOptionsKeywords", jsonOurResponse);
            }
        },

        async fetchOptionsGeoLocations({commit, rootGetters}) {
            let studObj = new ChartAPI();
            let jsonOurResponse = await studObj.sendRequest(
                "getGeolocationTags",
                rootGetters["currentProjectId"]
            );
            if (jsonOurResponse !== null) {
                commit("updateOptionsGeolocations", jsonOurResponse);
            }
        },

        selectGeoLocations({commit, state}, geoLocations) {
            // Логика автоматического отключения группировок при выборе городов
            if (geoLocations && geoLocations.length > 0) {
                // Проверяем, есть ли среди выбранных городов (frequency > 0)
                const hasCities = geoLocations.some(geo => geo.frequency > 0);
                
                // Проверяем, есть ли среди выбранных группировок (frequency = 0)
                const hasGroupings = geoLocations.some(geo => geo.frequency === 0);
                
                if (hasCities && hasGroupings) {
                    // Если выбраны и города, и группировки, оставляем только города
                    const filteredGeoLocations = geoLocations.filter(geo => geo.frequency > 0);
                    commit("updateGeoLocations", filteredGeoLocations);
                    return;
                }
            }
            
            commit("updateGeoLocations", geoLocations);
        },
        selectKeywordsTypes({commit}, KeywordsTypes) {
            commit("updateKeywordsTypes", KeywordsTypes);
        },
        selectKeywords({commit}, keywords) {
            commit("updateKeywords", keywords);
        },
        selectSlice({commit}, slice) {
            commit("updateSlice", slice);
        },
        selectDateRange({commit}, dateRange) {
            commit("updateDateRange", dateRange);
            let minutesToSubstract = 1440; // oneDay Minutes
            let differenceDateRange = Math.ceil(
                (dateRange.endDate.getTime() -
                    dateRange.startDate.getTime() +
                    minutesToSubstract * 60000) /
                (1000 * 3600 * 24)
            );
            let startDateComparing = "";
            let endDateComparing = "";
            if (dateRange.startDate.getDate() === dateRange.endDate.getDate()) {
                let yesterdayInit = new Date(dateRange.startDate);
                startDateComparing = yesterdayInit.setDate(yesterdayInit.getDate() - 1); // yesterday
                startDateComparing = endDateComparing = yesterdayInit;
            } else {
                startDateComparing = new Date(
                    dateRange.startDate.getTime() -
                    differenceDateRange * minutesToSubstract * 60000
                ); // a week ago
                startDateComparing.setHours(10);
                endDateComparing = new Date(
                    dateRange.startDate.getTime() - minutesToSubstract * 60000
                ); // a day ago
                endDateComparing.setHours(10);
            }

            commit("updateDateRangeComparing", {
                startDate: startDateComparing,
                endDate: endDateComparing,
            });
        },
        selectDateRangeComparing({commit}, dateRangeComparing) {
            commit("updateDateRangeComparing", dateRangeComparing);
        },
        selectComparing({commit}, comparing) {
            commit("updateComparing", comparing);
        },
        selectCompetitorsFilter({commit}, comparing) {
            commit("updateCompetitorsFilter", comparing);
        },
        selectAdvertisersFilter({commit}, comparing) {
            commit("updateAdvertisersFilter", comparing);
        },
        updateResultsPeriod({commit}, dateRange) {
            commit("updateResultsPeriod", dateRange);
        },
    },
    methods: {
        setWithExpiry(key, value, ttl) {
            const now = new Date();
            // `item` is an object which contains the original value
            // as well as the time when it's supposed to expire
            const item = {
                value: value,
                expiry: now.getTime() + ttl,
            };
            localStorage.setItem(key, JSON.stringify(item));
            sessionStorage.setItem(key, JSON.stringify(item));
        },
    },
    mutations: {
        /** Сброс «Тип слова», «Ключевые слова», «География» при переходе со страницы на страницу */
        resetKeywordsAndGeoOnNavigation(state) {
            state.keywordsTypes = [];
            state.keywords = [];
            state.geoLocations = [];
            localStorage.setItem("keywordsTypes", JSON.stringify([]));
            sessionStorage.setItem("keywordsTypes", JSON.stringify([]));
            localStorage.setItem("keywords", JSON.stringify([]));
            sessionStorage.setItem("keywords", JSON.stringify([]));
            localStorage.setItem("geolocation", JSON.stringify([]));
            sessionStorage.setItem("geolocation", JSON.stringify([]));
        },
        updateSearchEngines(state, searchEngines) {
            localStorage.setItem("searchEngines", JSON.stringify(searchEngines));
            sessionStorage.setItem("searchEngines", JSON.stringify(searchEngines));
            state.searchEngines = searchEngines;
        },
        updateDeviceTypes(state, deviceTypes) {
            localStorage.setItem("deviceTypes", JSON.stringify(deviceTypes));
            sessionStorage.setItem("deviceTypes", JSON.stringify(deviceTypes));
            state.deviceTypes = deviceTypes;
        },
        updateGeoLocations(state, geoLocations) {
            localStorage.setItem("geolocation", JSON.stringify(geoLocations));
            sessionStorage.setItem("geolocation", JSON.stringify(geoLocations));
            state.geoLocations = geoLocations;
        },
        updateKeywordsTypes(state, keywordsTypes) {
            localStorage.setItem("keywordsTypes", JSON.stringify(keywordsTypes));
            sessionStorage.setItem("keywordsTypes", JSON.stringify(keywordsTypes));
            state.keywordsTypes = keywordsTypes;
        },
        updateKeywords(state, keywords) {
            localStorage.setItem("keywords", JSON.stringify(keywords));
            sessionStorage.setItem("keywords", JSON.stringify(keywords));
            state.keywords = keywords;
        },
        updateOptionsKeywordsTypes(state, optionsKeywordsTypes) {
            state.optionsKeywordsTypes = optionsKeywordsTypes;
            
            // Восстанавливаем сохраненные фильтры из localStorage
            const savedKeywordsTypes = JSON.parse(localStorage.getItem("keywordsTypes")) || [];
            if (savedKeywordsTypes.length > 0) {
                // Фильтруем только те типы, которые есть в новых опциях
                const validKeywordsTypes = savedKeywordsTypes.filter(savedType => 
                    optionsKeywordsTypes.some(optionType => optionType.value === savedType.value)
                );
                state.keywordsTypes = validKeywordsTypes;
            }
        },
        updateOptionsKeywords(state, optionsKeywords) {
            state.optionsKeywords = optionsKeywords;
            
            // Восстанавливаем сохраненные фильтры из localStorage
            const savedKeywords = JSON.parse(localStorage.getItem("keywords")) || [];
            if (savedKeywords.length > 0) {
                // Фильтруем только те ключевые слова, которые есть в новых опциях
                const validKeywords = savedKeywords.filter(savedKeyword => 
                    optionsKeywords.some(optionKeyword => optionKeyword.value === savedKeyword.value)
                );
                state.keywords = validKeywords;
            }
        },
        updateOptionsGeolocations(state, optionsGeoLocation) {
            state.optionsGeoLocation = optionsGeoLocation;
            
            // Восстанавливаем сохраненные фильтры из localStorage
            const savedGeoLocations = JSON.parse(localStorage.getItem("geolocation")) || [];
            if (savedGeoLocations.length > 0) {
                // Фильтруем только те геолокации, которые есть в новых опциях
                const validGeoLocations = savedGeoLocations.filter(savedGeo => 
                    optionsGeoLocation.some(optionGeo => optionGeo.id === savedGeo.id)
                );
                state.geoLocations = validGeoLocations;
            }
        },
        updateSlice(state, slice) {
            localStorage.setItem("slice", JSON.stringify(slice));
            sessionStorage.setItem("slice", JSON.stringify(slice));
            state.slice = slice;
        },
        updateDateRange(state, dateRange) {
            setWithExpiry("dateRange", dateRange, 86400000); // 1 day = 86400000 ms
            state.dateRange = dateRange;
        },
        updateDateRangeComparing(state, dateRangeComparing) {
            setWithExpiry("dateRangeComparing", dateRangeComparing, 86400000); // 1 day = 86400000 ms
            state.dateRangeComparing = dateRangeComparing;
        },
        updateComparing(state, comparing) {
            localStorage.setItem("comparing", JSON.stringify(comparing));
            sessionStorage.setItem("comparing", JSON.stringify(comparing));
            state.comparing = comparing;
        },
        updateCompetitorsFilter(state, competitorsFilter) {
            state.competitorsFilter = competitorsFilter;
        },
        updateAdvertisersFilter(state, advertisersFilter) {
            state.advertisersFilter = advertisersFilter;
        },
        updateResultsPeriod(state, dateRange) {
            const regex = /\d{2}.\d{2}.\d{4}\s*-\s*\d{2}.\d{2}.\d{4}/;
            if (typeof dateRange === "string" && dateRange.match(regex)) {
                const pattern = /(\d{2})\.(\d{2})\.(\d{4})/;
                let dateRangeElement = dateRange.split("-");
                let startDate = new Date(
                    dateRangeElement[0].replaceAll(" ", "").replace(pattern, "$3-$2-$1")
                );
                let endDate = new Date(
                    dateRangeElement[1].replaceAll(" ", "").replace(pattern, "$3-$2-$1")
                );
                dateRange = {
                    startDate: startDate,
                    endDate: endDate,
                };
            }
        },
    },
    getters: {
        searchEngines(state) {
            return state.searchEngines;
        },
        getSearchEngines(state) {
            return state.searchEngines;
        },
        deviceTypes(state) {
            return state.deviceTypes;
        },
        getDeviceTypes(state) {
            return state.deviceTypes;
        },
        geoLocations(state) {
            return state.geoLocations;
        },
        keywordsTypes(state) {
            return state.keywordsTypes;
        },
        optionsKeywordsTypes(state) {
            return state.optionsKeywordsTypes;
        },
        keywords(state) {
            return state.keywords;
        },
        optionsKeywords(state) {
            return state.optionsKeywords;
        },
        optionsSearchEngines(state) {
            return state.optionsSearchEngines;
        },
        optionsDeviceTypes(state) {
            return state.optionsDeviceTypes;
        },
        slice(state) {
            return state.slice;
        },
        dateRange(state) {
            return state.dateRange;
        },
        dateRangeComparing(state) {
            return state.dateRangeComparing;
        },
        comparingState(state) {
            return state.comparing;
        },
        competitorsFilter(state) {
            return state.competitorsFilter;
        },
        advertisersFilter(state) {
            return state.advertisersFilter;
        },
        optionsGeoLocation(state) {
            return state.optionsGeoLocation;
        },
        resultsPeriod(state) {
            return state.resultsPeriod;
        },
        dateRangeString(state) {
            if (state.dateRange.startDate && state.dateRange.endDate) {
                return `${state.dateRange.startDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")} - ${state.dateRange.endDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")}`;
            } else {
                return "";
            }
        },
        dateRangeStringStartDate(state) {
            if (state.dateRange.startDate) {
                return `${state.dateRange.startDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")}`;
            } else {
                return "";
            }
        },
        dateRangeStringEndDate(state) {
            if (state.dateRange.endDate) {
                return `${state.dateRange.endDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")}`;
            } else {
                return "";
            }
        },
        dateRangeComparingString(state) {
            if (
                state.dateRangeComparing.startDate &&
                state.dateRangeComparing.endDate
            ) {
                return `${state.dateRangeComparing.startDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")} - ${state.dateRangeComparing.endDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")}`;
            } else {
                return "";
            }
        },
        dateRangeComparingStringStartDate(state) {
            if (state.dateRangeComparing.startDate) {
                return `${state.dateRangeComparing.startDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")}`;
            } else {
                return "";
            }
        },
        dateRangeComparingStringEndDate(state) {
            if (state.dateRangeComparing.endDate) {
                return `${state.dateRangeComparing.endDate
                    .toISOString()
                    .substring(0, 10)
                    .split("-")
                    .reverse()
                    .join(".")}`;
            } else {
                return "";
            }
        },
        deviceTypesParam(state) {
            let param = "";
            if (state.deviceTypes.length === 1) {
                if (state.deviceTypes[0] === "desktop") {
                    param = "&is_desktop=true";
                } else {
                    param = "&is_desktop=false";
                }
            }
            return param;
        },
        searchEngineParam(state) {
            let searchEngine = "";
            if (state.searchEngines.length === 1) {
                searchEngine = "&engine=" + state.searchEngines[0];
            }
            return searchEngine;
        },

        dateRangeParam(state, getters) {
            let startDateRangeString = getters.dateRangeString
                .split("-")[0]
                .replaceAll(" ", "")
                .split(".")
                .reverse()
                .join("-");
            let endDateRangeString = getters.dateRangeString
                .split("-")[1]
                .replaceAll(" ", "")
                .split(".")
                .reverse()
                .join("-");
            return `start_date=${startDateRangeString}&end_date=${endDateRangeString}`;
        },

        dateRangeComparingParam(state, getters) {
            let startDateRangeComparingString = getters.dateRangeComparingString
                .split("-")[0]
                .replaceAll(" ", "")
                .split(".")
                .reverse()
                .join("-");
            let endDateRangeComparingString = getters.dateRangeComparingString
                .split("-")[1]
                .replaceAll(" ", "")
                .split(".")
                .reverse()
                .join("-");
            return `start_date=${startDateRangeComparingString}&end_date=${endDateRangeComparingString}`;
        },

        dynamicDashboardParams(state, getters) {
            let startDateRangeComparingString = getters.dateRangeComparingString
                .split("-")[0]
                .replaceAll(" ", "")
                .split(".")
                .reverse()
                .join("-");
            let endDateRangeComparingString = getters.dateRangeComparingString
                .split("-")[1]
                .replaceAll(" ", "")
                .split(".")
                .reverse()
                .join("-");
            return `other_start_date=${startDateRangeComparingString}&other_end_date=${endDateRangeComparingString}`;
        },

        geoLocationsParam(state) {
            if (state.geoLocations) {
                let geoLocations = [];
                for (let i = 0, iLen = state.geoLocations.length; i < iLen; i++) {
                    geoLocations.push(state.geoLocations[i]["id"]);
                }
                return geoLocations.length > 0
                    ? "&geolocation_tag=" + geoLocations.join(",")
                    : "";
            } else {
                return "";
            }
        },

        competitorsParam(state) {
            return state.competitorsFilter
                ? "&competitor=" + state.competitorsFilter["id"]
                : "";
        },

        advertisersParam(state) {
            return state.advertisersFilter
                ? "&advertiser=" + state.advertisersFilter["id"]
                : "";
        },

        keywordsParam(state) {
            if (state.keywords) {
                let keywords = [];
                for (let i = 0, iLen = state.keywords.length; i < iLen; i++) {
                    keywords.push(state.keywords[i]["id"]);
                }
                return keywords.length > 0 ? "&keywords_id=" + keywords.join(",") : "";
            } else {
                return "";
            }
        },
        keywordsTypesParam(state) {
            if (state.keywordsTypes) {
                let keywords_types = [];
                for (let i = 0, iLen = state.keywordsTypes.length; i < iLen; i++) {
                    keywords_types.push(state.keywordsTypes[i]["value"]);
                }
                return keywords_types.length > 0
                    ? "&kw_type=" + keywords_types.join(",")
                    : "";
            } else {
                return "";
            }
        },
    },
};
